const Module = require("./lib/client/Module");
const ModuleWrapper = require("./lib/client/ModuleWrapper");
const InjectStyle = require("./lib/client/components/injectStyle");
const Modularize = require("./lib/client/ModularizeWithStyles");
const {
  useModuleContext,
  ModuleContext,
} = require("./lib/client/context/ModuleContext");
const {
  useI18n,
  I18nContext,
  I18nProvider,
} = require("./lib/client/context/I18nContext");
const useModuleEvent = require("./lib/client/hooks/useModuleEvent");
const useRestClient = require("./lib/client/hooks/useRestClient");
const useNativeEvents = require("./lib/client/hooks/useNativeEvents");
const useLifeCycleEvent = require("./lib/client/hooks/useLifeCycleEvent");
const useModuleLifeCycleEvent = require("./lib/client/hooks/useModuleLifeCycleEvent");

module.exports = {
  Module: ModuleWrapper,
  ModuleStandalone: Module,
  InjectStyle,
  Modularize,
  ModuleContext,
  useModuleContext,
  I18nContext,
  I18nProvider,
  useI18n,
  useRestClient,
  useNativeEvents,
  useModuleEvent,
  useModuleLifeCycleEvent,
  useLifeCycleEvent,
};
